module.exports = __webpack_public_path__ + "static/img/partner_XXIII.59a769f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_XXIII.png
// module id = cD84
// module chunks = 9